import { useEffect } from "react";

export default function useMobileNavResize({ setIsMobileNavOpen, isMobileNavOpen, megaNavName, setMegaNavName }) {
	useEffect(() => {
		const media = window.matchMedia("(max-width: 992px)");
		const resizeListener = () => {
			if (media.matches) {
				//hit mobile view
				if (megaNavName && !isMobileNavOpen) {
					setIsMobileNavOpen(true);
				}
			} else {
				//hit desktop view
				if (isMobileNavOpen) {
					setIsMobileNavOpen(false);
				}
			}
		};
		resizeListener();
		window.addEventListener("resize", resizeListener);

		return () => window.removeEventListener("resize", resizeListener);
	}, [isMobileNavOpen, megaNavName]);

	//TODO this could be a hook defined somewhere else
	//handle esc key to close megaNav, and maybe click anywhere outside?
	useEffect(() => {
		if (megaNavName) {
			window.addEventListener("keydown", closeMegaNav);
		} else {
			window.removeEventListener("keydown", closeMegaNav);
		}

		function closeMegaNav(e) {
			if (e.key === "Escape") {
				setMegaNavName("");
			}
		}

		return () => {
			window.removeEventListener("keydown", closeMegaNav);
		};
	}, [megaNavName, setMegaNavName]);
}
